import Vue from 'vue';
import Vuex, { MutationTree } from 'vuex';

Vue.use(Vuex);

interface State {
    closedMessageIds: number[];
}

const mutations: MutationTree<State> = {
    setClosedMessageId(currentState, appMessageId: number) {
        currentState.closedMessageIds.push(appMessageId);
    },
};

const getters = {
    closedMessageIds(currentState: State): number[] {
        return currentState.closedMessageIds;
    },
};

function initialState() {
    // If there's temporary close message ids, load them directly into the store.
    // @see src/vuex/utils/store.ts
    const tempClosedMessageIds = localStorage.getItem('tempClosedMessageIds');
    return {
        closedMessageIds: (tempClosedMessageIds ? JSON.parse(tempClosedMessageIds) : []) as number[],
    };
}

const state: State = initialState();

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
};

export default module;
